"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoClosed_redIcon = createIcon({
  displayName: "CompRegoClosed_redIcon",
  viewBox: "0 0 46 33",
  path: (
    <>
      <path
        d="M34.29,18.56l-2.93-2.89,4.34-4.33-4.34-4.28,2.93-2.94,4.39,4.33,4.34-4.33,2.98,2.94-4.39,4.28,4.39,4.33-2.98,2.89-4.34-4.28-4.39,4.28ZM16.73,16.5c-2.3,0-4.27-.81-5.91-2.42-1.64-1.62-2.46-3.56-2.46-5.83s.82-4.21,2.46-5.83c1.64-1.62,3.61-2.42,5.91-2.42s4.27.81,5.91,2.42c1.64,1.62,2.46,3.56,2.46,5.83s-.82,4.21-2.46,5.83c-1.64,1.62-3.61,2.42-5.91,2.42ZM0,33v-5.77c0-1.17.3-2.24.91-3.22.61-.98,1.42-1.73,2.43-2.24,2.16-1.07,4.36-1.86,6.59-2.4,2.23-.53,4.5-.8,6.8-.8s4.57.27,6.8.8c2.23.53,4.43,1.33,6.59,2.4,1.01.52,1.82,1.26,2.43,2.24.61.98.91,2.05.91,3.22v5.77H0ZM4.18,28.88h25.09v-1.65c0-.38-.1-.72-.29-1.03-.19-.31-.44-.55-.76-.72-1.88-.93-3.78-1.62-5.7-2.09-1.92-.46-3.85-.7-5.8-.7s-3.89.23-5.8.7c-1.92.46-3.82,1.16-5.7,2.09-.31.17-.57.41-.76.72-.19.31-.29.65-.29,1.03v1.65ZM16.73,12.38c1.15,0,2.13-.4,2.95-1.21.82-.81,1.23-1.78,1.23-2.91s-.41-2.11-1.23-2.91c-.82-.81-1.8-1.21-2.95-1.21s-2.13.4-2.95,1.21c-.82.81-1.23,1.78-1.23,2.91s.41,2.11,1.23,2.91c.82.81,1.8,1.21,2.95,1.21Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
    color: "red.500",
  },
});

export default CompRegoClosed_redIcon;
